import React, { useEffect } from 'react'
import { Dropdown, DropdownMenuItemType } from 'office-ui-fabric-react/lib/Dropdown';
import { DefaultButton, IconButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import River  from './filterComponents/River';
import Location from './filterComponents/Location';

const stats = (props) => {
  const { plot, plotIndex, favorites, userFavorites, loadYears } = props;

  let changed = false
  const applied = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.appliedFilters));
  const last = JSON.stringify((({ method, source, river, locations, type, alternatives }) => ({ method, source, river, locations, type, alternatives }))(plot.lastApplied));
  if(applied !== last){
    changed = true
  }
  // console.log('last applied: ', plot.lastApplied);

  let keyLocations = plot.availableFilters && plot.availableFilters.favorites && plot.availableFilters.favorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });
  let userFav = userFavorites.map(({source, source_id, river, river_id, location, location_id}) => {
    return {
      key: `${source_id}-${river_id}-${location_id}`,
      source_id,
      river_id,
      location_id,
      text: `${location}`
    }
  });

  if(userFav.length === 0){
    userFav = [{
      key: 'disabled',
      text: 'No locations identified',
      disabled: true
    }]
  }

  if(!keyLocations){
    keyLocations = []
  }
  let options = [
    { key: 'myLocs', text: 'My Locations', itemType: DropdownMenuItemType.Header },
    ...userFav,
    { key: 'keyLocs', text: 'Key Locations', itemType: DropdownMenuItemType.Header },
    ...keyLocations
  ];

  let disabled = false;
  if(!plot.appliedFilters.source) disabled = true;
  if(!plot.appliedFilters.river) disabled = true;
  if(!plot.appliedFilters.locations.length) disabled = true;
  if(!plot.appliedFilters.type) disabled = true;
  if(!plot.appliedFilters.alternatives.length) disabled = true;
  if(plot.isLoading) disabled = true;
  if(isNaN(plot.appliedFilters.startDate)) disabled = true;

  useEffect(() => {

    if(plot.bulkData && !isNaN(plot.appliedFilters.startDate)){
      if(!plot.bulkData[plot.appliedFilters.startDate]){
        if(plot.appliedFilters.startDate >= 1931 && plot.appliedFilters.startDate <= 2012){
          const myTimeout = setTimeout(() => {
            loadYears({...plot.appliedFilters}, plotIndex)
          }, 400)
          return () => clearTimeout(myTimeout);
        }
      } else {
        props.setPlotData(props.buildStatsPlot(plot.bulkData, plot.appliedFilters.startDate, plotIndex), plotIndex);
      }
    }
  }, [plot.appliedFilters.startDate])

  return (
    <div>
      {
        favorites ? (
          <Dropdown 
            placeHolder='Select a Location'
            disabled={!plot.appliedFilters.method}
            id='location-dropdown'
            className={plot.appliedFilters.source && plot.appliedFilters.river && plot.appliedFilters.locations.join('') ? '' : 'empty' }
            selectedKey={`${plot.appliedFilters.source}-${plot.appliedFilters.river}-${plot.appliedFilters.locations.join('')}`}
            onChange={(e, option) => {
              let { source_id, river_id, location_id } = option;
              props.changeFilter({source: source_id, river: river_id, locations: [location_id]}, plotIndex, 'favorite')
            }}
            options={ options }
          />
        ) : (
          <React.Fragment>
            <Dropdown
              placeHolder="Select a Source"
              disabled={!plot.appliedFilters.method}
              className={plot.appliedFilters.source ? '' : 'empty'}
              id="type-dropdown-filter"
              selectedKey={plot.appliedFilters.source}
              onChange={(e, option) => props.changeFilter({source: option.key}, plotIndex, 'source')}
              options={ plot.availableFilters.sources.map(({source_id, source}) => ({key: source_id, text: source === 'RIVER' ? 'HEC RAS' : 'RESSIM'})) }
            />
            <Dropdown
              placeHolder="Select a River"
              disabled={!plot.appliedFilters.source}
              className={plot.appliedFilters.river ? '' : 'empty'}
              id="type-dropdown-filter"
              onRenderOption={(props) => <River {...props} />}
              onDismiss={() => props.setMap(null)}
              selectedKey={plot.appliedFilters.river}
              onChange={(e, option) => props.changeFilter({river: option.key}, plotIndex, 'river')}
              options={ plot.availableFilters.rivers.map(({river_id, river}) => ({key: river_id, text: river})) }
            />
            <Dropdown
              disabled={ !plot.appliedFilters.river }
              placeHolder="Select Location"
              className={plot.appliedFilters.locations && plot.appliedFilters.locations.length ? '' : 'empty'}
              id="location-dropdown"
              selectedKey={ plot.appliedFilters.locations }
              onRenderOption={(props) => <Location {...props} river={plot.appliedFilters.river} favorites={userFav}/>}
              onChange={(e, option) => props.changeFilter({locations: [option.key]}, plotIndex, 'location')}
              options={ plot.availableFilters.locations.map(({location_id, location}) => ({key: location_id, location_id ,text: location})) }
            />
          </React.Fragment>
        )
      }
      <Dropdown
        placeHolder="Select a Type"
        disabled={ !plot.appliedFilters.locations.length }
        className={plot.appliedFilters.type ? '' : 'empty'}
        id="type-dropdown-filter"
        selectedKey={plot.appliedFilters.type}
        onChange={(e, option) => {
          props.changeFilter({type: option.key}, plotIndex, 'type');
          props.editChartY({title: option.text}, plotIndex);
        }}
        options={ plot.availableFilters.types.map(({type_id, type, unit}) => ({key: type_id, text: `${type} - (${unit})`})) }
      />
      <Dropdown
        disabled={ !plot.appliedFilters.locations.length }
        placeHolder="Select an Alternative"
        className={plot.appliedFilters.alternatives && plot.appliedFilters.alternatives.length ? '' : 'empty'}
        selectedKey={plot.appliedFilters.alternatives}
        onChange={(e, option) => props.changeFilter({alternatives: [option.key]}, plotIndex, 'alternative')}
        options={ plot.availableFilters.alternatives.map(({alternative_id, short_name}) => ({key: alternative_id, text: short_name})) }
      />
      <DefaultButton
        className={`apply-filter${(changed && !disabled) ? ' changed' : ''}`}
        disabled={disabled}
        text="Apply"
        primary
        onClick={ () => props.applyFilters({...plot.appliedFilters}, plotIndex) }
      />
      { (changed && !disabled) ? (<div className='changed-warning'>Filters have changed since last applied. Click apply to update data.</div>) : null }
      <div className='year-picker'>
        <IconButton
          primary 
          iconProps={{iconName: 'ChevronLeft'}}
          disabled={ disabled || (plot.appliedFilters.startDate && (plot.appliedFilters.startDate < 1932)) }
          onClick={() => {
            let date = {...plot.appliedFilters}.startDate;
            if(!date) date = 2012;
            date = date - 1;
            props.changeFilter({startDate: date}, plotIndex, 'date');
          }}
        />
        <TextField
          value={ plot.appliedFilters.startDate }
          placeholder='Enter a Year'
          type='number'
          min={ 1931 }
          max={ 2012 }
          step={ 1 }
          onChange={(e, value) => {
            let date = parseInt(value, 10);
            props.changeFilter({startDate: date}, plotIndex, 'date');
          }}
        />
        <IconButton
          iconProps={{iconName: 'ChevronRight'}}
          disabled={ disabled || (!plot.appliedFilters.startDate || (plot.appliedFilters.startDate && (plot.appliedFilters.startDate > 2011))) }
          onClick={() => {
            let date = {...plot.appliedFilters}.startDate || 2012;
            date = date += 1;
            props.changeFilter({startDate: date}, plotIndex, 'date');
          }}
        />
      </div>
    </div>
  )
}

export default stats



// WEBPACK FOOTER //
// ./src/components/panel/items/filters/stats.js